document.addEventListener("DOMContentLoaded", function() {
    setTimeout(function(){
        loadProductRecommendations();
        loadCategoryRecommendations();
        loadNoAnchorRecommendations();
    }, 1000);
});
const CONST = require('plugin_frontend_core/constants');

/**
 * Validates and Return the cquotient namespace provided by the commerce cloud platform
 */
function getEinsteinUtils()  {
    var einsteinUtils = window.CQuotient;
    if (einsteinUtils && (typeof einsteinUtils.getCQUserId == 'function') && (typeof einsteinUtils.getCQCookieId == 'function')) {
        return einsteinUtils;
    }
    return null;
}

/**
 * Gets all product placeholder elements, which hold einstein recommendations queries the details from the
 * einstein engine and feeds them back to the dom element
 */
function loadProductRecommendations() {
    var einsteinUtils = getEinsteinUtils();
    if (einsteinUtils) {
        var recommendationTiles = Array.from(document.querySelectorAll('.einstein-product-recommendations'));
        recommendationTiles.forEach(parentElement => processRecommendationsTile(parentElement, einsteinUtils, createProductAnchor(parentElement)));
    }
}
/**
 * Processes a recommendation tile, with an already initialized product specific anchors array
 */
function createProductAnchor(parentElement) {
    var einsteinParameters = parentElement.dataset;
    return [{ id: einsteinParameters.primaryProductId, sku: einsteinParameters.secondaryProductId, type: einsteinParameters.alternativeGroupType, alt_id: einsteinParameters.alternativeGroupId }];
}

/**
 * Gets all category placeholder elements, which hold einstein recommendations queries the details from the
 * einstein engine and feeds them back to the dom element
 */
function loadCategoryRecommendations() {
    var einsteinUtils = getEinsteinUtils();
    if (einsteinUtils) {
        var recommendationTiles = Array.from(document.querySelectorAll('.einstein-category-recommendations'));
        recommendationTiles.forEach(parentElement => processRecommendationsTile(parentElement, einsteinUtils, createCategoryAnchor(parentElement)));
    }
}
/**
 * Rerieves data attributes from parent element and converts to gretel compatible recommenders array
 */
function createCategoryAnchor(parentElement) {
    var einsteinParameters = parentElement.dataset;
    return [{ id: einsteinParameters.categoryId }];
}

/**
 * Gets all placeholder elements, which hold einstein recommendations queries the details from the
 * einstein engine and feeds them back to the dom element
 */
function loadNoAnchorRecommendations() {
    var einsteinUtils = getEinsteinUtils();
    if (einsteinUtils) {
        var recommendationTiles = Array.from(document.querySelectorAll('.einstein-noanchor-recommendations'));
        recommendationTiles.forEach(parentElement => processRecommendationsTile(parentElement, einsteinUtils));
    }
}

/**
 * Processes a recommendation tile, with an already initialized category specific anchors array
 */
function processRecommendationsTile(parentElement, einsteinUtils, anchorsArray) {
    var einsteinParameters = parentElement.dataset;
    var recommender = einsteinParameters.recommender;

    var params = {
        userId   : einsteinUtils.getCQUserId(),
        cookieId : einsteinUtils.getCQCookieId(),
        ccver    : '1.01'
    };

    if (anchorsArray) {
        params.anchors = anchorsArray;
    };

    function recommendationsReceived(einsteinResponse) {
        fillEinsteinDomElement(einsteinResponse, parentElement);
    }

    if (einsteinUtils.getRecs) {
        einsteinUtils.getRecs(einsteinUtils.clientId, recommender, params, recommendationsReceived);
    } else {
        einsteinUtils.widgets = einsteinUtils.widgets || [];
        einsteinUtils.widgets.push({
            recommenderName : einsteinParameters.recommender,
            parameters      : params,
            callback        : recommendationsReceived
        });
    }
}

/**
 * Renders the einstein response into a given dom element
 */
function fillEinsteinDomElement(einsteinResponse, parentElement) {
    const recommendedProducts = einsteinResponse[parentElement.dataset.recommender].recs;

    if (recommendedProducts && recommendedProducts.length > 0) {
        const template = parentElement.dataset.template;
        const components = recommendedProducts.map(recommendedProduct => {
            const tileDefinition = {};
            tileDefinition.template = template;
            tileDefinition.model = {type: 'product', id : recommendedProduct.id};
            return tileDefinition;
        });

        // Fire 'einstein:recommendationsReady' custom event to allow adjustments on the payload for various purposes.
        // For now, it is known that for GTM events enhancement on the payload is needed.
        $(document).trigger('einstein:recommendationsReady', {
            recommendationComponents: components,
            productTilesCarousel: parentElement
        });

        const url = new URL(parentElement.dataset.productLoadUrl);
        $.ajax({
            url: url.href,
            type: 'get',
            dataType: 'html',
            data: {
                components: JSON.stringify(components),
                limit: parentElement.dataset.limit
            },
            success: function (data) {
                if (data) {
                    parentElement.innerHTML = data;
                    $('body').trigger(CONST.events.einsteinLoaded, { parent: parentElement });
                    $('body').trigger(CONST.events.calculateWaardechequePrices);
                }
            },
            error: function (e) {
                // In case of error remove the container and its title.
                const container = document.getElementById(parentElement.dataset.containerId);
                container.remove();
            }
        });
    }
}
